import Vue from 'vue'

export const ImageMixin = Vue.extend({
  data() {
    return {
      file: null as File | null,
    }
  },
  methods: {
    changeImage(): void {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.oninput = e => {
        const { files } = e.target as HTMLInputElement
        if (!files || !files.length) return
        this.file = files[0]
        this.$emit('input', this.file)
        input.remove()
      }
      input.click()
    },
  },
})
